  <template>
  <div class="asset-item position-relative mx-2 mt-2 mb-0 rounded"
       :id="componentId">
    <MediaContent :posterImage="item.backdropSmall"
                  :programmeMetadata="item"
                  :keepInitiated="promoMode"
                  :isLocked="isLocked || (item.isLive && checkIfLiveVideoIsPending())"
                  :isVisible="isVisible"
                  :ref="`${this.componentId}_mediaContent`"
                  @contentClicked="onContentClicked"
                  v-observe-visibility="onVisibilityChanged"/>
    <LiveStreamInfo v-if="shouldLiveInfoBeVisible" :item=item />
    <div class="asset-badge fas fa-lock" v-if="!displayPoster && isLocked" />
    <div class="pb-3 pl-3 pr-3 pt-2 col-12">
      <p id="title" class="col-12 pl-0 pr-0">{{item.title}}</p>
      <RatingInfo :item="item" v-if="!item.externalLink && item.durationFormatted !== '0 mins'"/>
      <div id="expanded" class="col-12 pl-0 pr-0">
        <div id="buttons" class="asset-item-buttons vld-parent row">
          <Recommend :item="this.item" v-if="!displayPoster && !isLocked" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { ObserveVisibility } from 'vue-observe-visibility'
import RatingInfo from './RatingInfo.vue'
import Recommend from '../components/buttons/Recommend'
import LiveStreamInfo from '../components/LiveStreamInfo.vue'
import MediaContent from '../components/MediaContent'

export default {
  page: 'asset',
  directives: { 'observe-visibility': ObserveVisibility },
  components: {
    RatingInfo,
    Recommend,
    LiveStreamInfo,
    MediaContent
  },
  data: function () {
    return {
      componentId: `asset_${this.item.progId}`,
      isVisible: false,
      shouldLiveInfoBeVisible: false
    }
  },
  props: ['item', 'displayPoster', 'isShared', 'promoMode'],
  computed: {
    ...mapState({
      isBeta: state => state.isBeta,
      isRegisteredUser: state => state.isRegisteredUser
    }),
    isLocked: function () {
      if (this.isShared) {
        return false
      }
      if (this.item.isPlaceholder) {
        return false
      }
      if (this.isBeta && !this.isRegisteredUser) {
        return true
      }
      const signUpRequired = this.item.flags && this.item.flags.indexOf('SignupRequired') !== -1
      return signUpRequired && !this.isRegisteredUser
    }
  },
  created () {
    if (this.item.isPlaceholder) {
      return
    }
    this.storeUnsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case 'updateTime':
          this.checkIfLiveVideoIsPending()
          break
      }
    })

    this.checkIfLiveVideoIsPending()
  },
  beforeDestroy () {
    this.storeUnsubscribe()
  },
  methods: {
    checkIfLiveVideoIsPending () {
      if (this.item && this.item.isLive && this.item.liveInfo && this.item.liveInfo.YOUTUBE_LIVE_SCHEDULED_START_TIME) {
        const startTime = new Date(this.item.liveInfo.YOUTUBE_LIVE_SCHEDULED_START_TIME)
        const now = new Date()
        this.shouldLiveInfoBeVisible = (now < startTime)
        return (now < startTime)
      }
    },

    onItemClick () {
      if (this.isLocked) {
        this.$store.commit('startSignIn', 'CONTENT_BLOCKED')
        return
      }
      this.$refs[`${this.componentId}_mediaContent`].onPosterClick()
    },

    onContentClicked () {
      if (this.isLocked) {
        this.$store.commit('startSignIn', 'CONTENT_BLOCKED')
      }
    },

    onVisibilityChanged (isVisible) {
      this.isVisible = isVisible
    }
  }
}
</script>
